import type { paths } from '@orlikfy/api-interfaces';

export type {
  ApproveManyGamePlayerApplicationsDto,
  ApproveManyGamePlayerApplicationsResponseDto,
  ApproveManyGamePlayerApplicationsResponseDtoGamePlayer,
  RejectManyGamePlayerApplicationsDto
} from '@orlikfy/api-interfaces';

// POST /hosted-games/{hostedGameId}/applications/approve-many
export const APPROVE_MANY_APPLICATIONS_PATH =
  '/hosted-games/{hostedGameId}/applications/approve-many' as const satisfies keyof paths;
type ApproveManyApplicationsOperation = paths[typeof APPROVE_MANY_APPLICATIONS_PATH]['post'];
export type ApproveManyApplicationsPathParams = ApproveManyApplicationsOperation['parameters']['path'];
export type ApproveManyApplicationsBody =
  ApproveManyApplicationsOperation['requestBody']['content']['application/json'];
export type ApproveManyApplicationsResponse =
  ApproveManyApplicationsOperation['responses'][200]['content']['application/json'];

// POST /hosted-games/{hostedGameId}/applications/reject-many
export const REJECT_APPLICATIONS_PATH =
  '/hosted-games/{hostedGameId}/applications/reject-many' as const satisfies keyof paths;
type RejectApplicationsOperation = paths[typeof REJECT_APPLICATIONS_PATH]['post'];
export type RejectApplicationsPathParams = RejectApplicationsOperation['parameters']['path'];
export type RejectApplicationsBody = RejectApplicationsOperation['requestBody']['content']['application/json'];
